import {flow, types} from 'mobx-state-tree';
import * as api from '../../services/api';
import {ListingModel} from '../ListingsListModel';

export const FetchAirbnbListingsModel = types
  .model('FetchAirbnbListingsModel', {
    isLoading: types.optional(types.boolean, false),
    listings: types.maybe(types.array(ListingModel))
  })
  .actions(self => {
    return {
      fetchAirbnbListings: flow(function*(
        accountId: number,
        otaListingIds: number[],
        refresh: boolean,
        callback: Function
      ) {
        self.isLoading = true;
        const response = yield api.fetchAirbnbListings(
          accountId,
          otaListingIds,
          refresh
        );
        if (response && response.status === 200 && response.data) {
          self.listings = response.data.listings;
          callback('error', 'Fetch Airbnb Listings Successfully');
        } else {
          callback('error', 'Fetch AirbnbListings Errors');
        }
        self.isLoading = false;
      })
    };
  });

export type FetchAirbnbListingsModelType = typeof FetchAirbnbListingsModel.Type;



// WEBPACK FOOTER //
// ./src/models/IntegrationModel/IntegrationModel.ts